export const OTHER_VALUE = 'other';
export const MAX_TEXT_LIMIT = 2000;
